import Button from 'components/_parts/atoms/button';
import CustomTable from 'components/_parts/atoms/table';
import LoadingCustom from 'components/layouts/loading/loading';
import dayjs from 'dayjs';
import { useOuterClick } from 'providers/OutsideClick';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ModalActivityType from '../modal';
import dataStatus from './dataStatus';

interface PropsType {
  t : (e:string) => string
}

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;
const ButtonEdit = styled(Button)`
  width: 100%;
  max-width: 70px;
  height: 24px;
  float: right;
`;
const CustomTableMod = styled.div`
  [data-column-id="1"] {
    min-width: 10%;
    tex-align: left;
  }
  .rdt_TableBody {
    height: 500px;
    overflow: auto;
  }
`;

const customStyles = {
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: 'Quicksand',
      padding: '0px',
      justifyContent: 'start',
    },
  },
  cells: {
    style: {
      padding: '0px',
      justifyContent: 'start',
    },
  },
  rows: {
    style: {
      fontFamily: 'Quicksand',
      minHeight: '35px', // override the row height
      borderRadius: 0,
      filter: 'none',
      borderBottom: 'unset !important',
    },
  },
};

function Index(props: PropsType) {
  const { t } = props;
  const [showModal, setShowModal] = useState(false);
  const [id, setId] = useState(null);
  const [dataEdit, setDataEdit] = useState(null);
  const [typeForm, setTypeForm] = useState('');
  const { CategoryList, keyCategoryGroup } = useSelector((state) => ({
    CategoryList: state?.company?.custom_management,
    keyCategoryGroup: state?.loading?.listKey?.companyCategoryGroup,
  }));
  const innerRef = useOuterClick((e) => {
    if (
      e?.srcElement?.className && (e.srcElement?.className === 'modal fade show'
            || e.srcElement?.className?.includes('cs_modal-bg'))
    ) {
      setShowModal(false);
      setId(null);
    }
  });
  const dataStatusCell = (row, t) => (
    <div className="custom_wla-collapsible-content-right-status text-capitalize">
      {dataStatus({ data: row.status, t })}
    </div>
  );

  const actionUpdate = ({ data, i }) => (
    <ButtonEdit
      icon="edit"
      func={() => {
        setShowModal(true);
        setTypeForm('edit');
        setId(i);
        setDataEdit(data);
      }}
    >
          &nbsp;&nbsp;
      {t('org.structure_view.modal.edit')}
    </ButtonEdit>
  );

  const conditionalRowStyles = [
    {
      when: (row) => row.status === 'deleted',
      style: {
        display: 'none',
      },
    },
  ];

  const columns = [
    {
      name: 'No',
      sortField: true,
      selector: (_, i) => i + 1,
      cellStyle: { verticalAlign: 'middle' },
      width: 'fit-content',
    },
    {
      name: t('biz_process.tree.title'),
      sortField: true,
      selector: (row) => row.title,
    },
    {
      name: t('job_desc.status'),
      sortField: true,
      cell: (row) => dataStatusCell(row, t),
    },
    {
      name: t('org.index_view.last_update'),
      sortField: true,
      selector: (row) => dayjs(row.updated_at).format('D MMM YYYY') ?? '-',
      center: true,
      width: '20%',
    },
    {
      name: t('org.employee.action'),
      sortField: true,
      style: {
        justifyContent: 'center',
      },
      center: true,
      width: '15%',
      cell: (row, i) => actionUpdate({ data: row, i }),
    },
  ];

  return (
    <>
      {showModal && (
        <ModalActivityType
          innerRef={innerRef}
          modal={showModal}
          funcModal={setShowModal}
          ids={id}
          data={dataEdit}
          funcId={() => setId}
          typeForm={typeForm}
          t={t}
        />
      )}
      <div
        className="tab-pane active position-relative"
        id="custom_category_list"
        role="tabpanel"
        style={{
          minHeight: '700px',
        }}
      >
        { keyCategoryGroup ? <LoadingCustom style={{ height: '100px' }} /> : (
          <>
            <div className="row">
              <div className="col-8">
                <h4 className="title">{t('workload_landing.custom_category')}</h4>
              </div>
              <div className="col-4">
                <ButtonMod
                  icon="create"
                  func={() => {
                    setShowModal(true);
                    setTypeForm('create');
                    setDataEdit(null);
                  }}
                >
                  &nbsp;&nbsp;
                  {t('board.add')}
                </ButtonMod>
              </div>
            </div>
            <CustomTableMod>
              <CustomTable
                columns={columns}
                data={CategoryList}
                customStyles={customStyles}
                conditionalRowStyles={conditionalRowStyles}
              />
            </CustomTableMod>
          </>
        )}
      </div>
    </>
  );
}

export default Index;
